<div class="d-flex flex-column justify-content-start w-100 px-2 form-container">
  <div class="listing unit-list mt-4">
    <div class="scroll-container">
      <div class="overflow-y">
        <ng-container
          *ngFor="
            let accessItem of selectedCredentials?.cardAccess | keyvalue;
            let i = index
          "
        >
          <h2 class="selected-access bold">
            <ng-container *ngIf="accessItem.key === CONSTANTS.HOME_ACCESS">
              {{ 'HOME_ACCESS' | translate }}
            </ng-container>
              <ng-container *ngIf="accessItem.key === CONSTANTS.OTHER_ACCESS && commonAccessControl">
                {{ 'OTHER_ACCESS' | translate }}
              </ng-container>
            <ng-container *ngIf="accessItem.key === CONSTANTS.TEMPORARY_ACCESS">
              {{ 'TEMPORARY_ACCESS' | translate }}
            </ng-container>
          </h2>
          <ng-container *ngIf="accessItem?.value?.length < 1">
            <div class="group-container mb-1 mr-2">
              <div class="form-group rounded-top form-container">
                <div class="w-100 building-list-container">
                  <div class="list-box full mr-2">
                    <div class="text-center">
                      {{ 'NO_ACCCESS_TO_SHOW' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container
            *ngFor="let accessObj of accessItem.value; let j = index"
          >
            <div class="w-100 building-list-container">
              <div [ngClass]="{'d-flex list-box full mr-2': accessObj.entityType !== CONSTANTS.ACCESS_POINT ||commonAccessControl }">
                <span class="col-2 align-self-center">
                    <img
                  
                    *ngIf="
                      accessObj?.entityType === CONSTANTS.ENTITY_ACCESS_POINT &&
                      commonAccessControl
                    "
                    alt="User Icon"
                    src="assets/svg/ico-construct-outline.svg"
                    class="setting-icon"
                  />
                  <img
                    *ngIf="accessObj?.entityType === CONSTANTS.LOCK"
                    alt="User Icon"
                    src="assets/svg/ico-lock.svg"
                    class="lock-icon"
                  />
                  <img
                    *ngIf="!accessObj?.entityType"
                    alt="User Icon"
                    src="assets/svg/ico-construct-outline.svg"
                    class="setting-icon"
                  />
                </span>
                <div class="col-9">
                    <ng-container *ngIf ="accessObj.entityType === CONSTANTS.ACCESS_POINT  &&
                    commonAccessControl">
                      <div
                      class="col-12 bold heading3"
                      [class.expired]="accessObj?.isExpired"
                    >
                      <app-profile-tooltip [showHelpCursor]="true">
                        {{
                          (accessObj?.entityType || "") +
                            " " +
                            (accessObj?.entityName || "")
                        }}
                      </app-profile-tooltip>
                    </div>
                    </ng-container>
              
                  <ng-container *ngIf ="accessObj.entityType === CONSTANTS.LOCK">
                    <div
                    class="col-12 bold heading3"
                    [class.expired]="accessObj?.isExpired"
                  >
                    <app-profile-tooltip [showHelpCursor]="true">
                      {{
                        (accessObj?.entityType || "") +
                          " " +
                          (accessObj?.entityName || "")
                      }}
                    </app-profile-tooltip>
                  </div>
                  </ng-container>                 
                  <ng-container
                    *ngIf="accessObj?.entityType === CONSTANTS.LOCK"
                  >
                    <div
                      class="col-12 status"
                      [class.expired]="accessObj?.isExpired"
                    >
                      <app-profile-tooltip [showHelpCursor]="true">
                        {{
                          (accessObj?.unitName || ("UNIT" | translate)) +
                            ", " +
                            (accessObj?.buildingName || "")
                        }}
                      </app-profile-tooltip>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="accessObj?.entityType !== CONSTANTS.LOCK &&
                    commonAccessControl"
                  >
                    <div
                      class="col-12 status"
                      [class.expired]="accessObj?.isExpired"
                    >
                      <app-profile-tooltip [showHelpCursor]="true">
                        {{
                          (accessObj?.floorName || ("FLOOR" | translate)) +
                            ", " +
                            (accessObj?.buildingName || "")
                        }}
                      </app-profile-tooltip>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
